import { api } from './service';
import * as dd from 'dingtalk-jsapi';

// 授权配置
const AUTH_INFO = {
    authAppid: authAppid,
    c_appid: '',
    scope: 'snsapi_base'
};
// 监测配置
const TAR_INFO = {
    tar_debug: false,
    tar_tid: tarTid,
    tar_token: tarToken,
    tar_userinfo: [],
    tar_black: false
};
// 分享配置
const WX_SHARE = {
    title: shareTitle,
    desc: shareDesc,
    link: window.location.href.split('?')[0],
    imgUrl: shareImgUrl,
    success: function () {
        $(".shadow").remove();
    },
    cancel: function () { }
};

//授权appid在APPID_ARR中c_appid=wxd8ca4f9b12c1f306，才能完成内部公众号授权
//wxe8cf03c0fb20daea 百加得服务号
//wxdf345e11623cc2e3 欧莱雅服务号
const APPID_ARR = [
    'wx522612908ac74c9c',
    'wx2146e80f40ccb9a2',
    'wx2b6316e75157fd10',
    'wx4ee881be25cc499b',
    'wx6e40c992d0e1789c',
    'wx8464e248296848a6',
    'wxabc64e199ab51ddd',
    'wxae443fc803e5af1c',
    'wxb0dd47d740a0b327',
    'wxe512506924dfd7b6',
    'wxfa065f3046ad9c21',
    'wx03d4e22cfa146659',
    'wx8c40f76a9c5355e7',
    'wxe8cf03c0fb20daea',
    'wxf1010d8359a17413'
];

if (APPID_ARR.includes(AUTH_INFO.authAppid)) {
    AUTH_INFO.c_appid = "wxd8ca4f9b12c1f306";
} else {
    AUTH_INFO.c_appid = "wx15522600325215c1";
}

//不同version的域名数组
const DOMAIN_ARR = {
    busone: [
        'file.3zsp0.cn',
        'file.qaats.cn',
        'file.hjsia.cn',
        'file.ruokdude.cn',
        'file.nicolasmr4.cn',
        'file.snakeslack.cn',
        'file.whoismyfav.cn',
        'file.ilovephplang.cn',
        'file.phpisthebestlang.cn',
        'file.tarssredevops.cn',
        'file.sre-devops.cn',
        'file.dudeimjerry.cn',
        'file.givemefivesix.cn',
        'file.tarsgalaxyforce.cn',
        'file.chonggouwh.cn',
        'file.cgymba.cn',
        'file.chongouad.cn',
        'file.heheecs.cn',
        'file.hiweplay.cn',
        'file.canandian.cn',
        'file.cgwljt.cn',
        'file.cgylgs.cn',
        'file.chonggouad.cn',
        'file.cgxxyl.cn',
        'file.cgxxkj.cn',
        'file.cgxxwl.cn',
        'file.cgcmkj.cn',
        'file.tssredevops.cn',
        'file.doubletwelve.cn',
        'file.wowwebulei.cn',
        'file.lbxxdx.cn'
    ],
    carsonone: [
        'file.hzhhqy.cn',
        'file.hzhhonline.cn',
        'file.hzhhwebsite.cn',
        'file.hzhhdesign.cn',
        'file.hzhhasia.cn',
        'file.hzhhshop.cn',
        'file.hzhhcmi.cn',
        'file.hzhhenv.cn',
        'file.hzhhcity.cn',
        'file.hzhhyule.cn',
        'file.hzhhxxkj.cn',
        'file.hzhhcom.cn',
        'file.hzhhclub.cn',
        'file.hzhhkpi.cn',
        'file.hzhhyxgs.cn',
        'file.hzhhreal.cn',
        'file.hzhhstore.cn',
        'file.hzhhinfo.cn',
        'file.hzhhcloud.cn',
        'file.hzhhkeji.cn',
    ]
};


const getUrlParam = function (param) {
    return new URL(window.location.href).searchParams.get(param);
}

const not_wx_dd_init = function () {
    tar.init(TAR_INFO);
}

const dd_init = function () {
    dd.ready(function () {
        api.encrypt({
            t: parseInt(Math.random() * 100000),
            tar_eventid: TAR_INFO.tar_tid
        }).then((res) => {
            const sharedata = res.sharedata || {};
            dd.biz.navigation.setRight({
                show: true, // 控制按钮显示， true 显示， false 隐藏， 默认true
                control: true, // 是否控制点击事件，true 控制，false 不控制， 默认false
                text: '···', // 控制显示文本，空字符串表示显示默认文本
                onSuccess: function (result) {
                    // 如果control为true，则onSuccess将在发生按钮点击事件被回调
                    dd.biz.util.share({
                        type: 0, // 分享类型，0:全部组件 默认； 1:只能分享到钉钉；2:不能分享，只有刷新按钮
                        url: window.location.href,
                        title: sharedata.share_title || Constant.title,
                        content: sharedata.share_desc || Constant.desc,
                        image: sharedata.share_img || Constant.imgurl,
                        onSuccess: function () {
                            // onSuccess将在调起分享组件成功之后回调
                            // console.log('分享成功')
                        },
                        onFail: function (err) {
                            console.error('分享失败')
                        }
                    })
                },
                onFail: function (err) {
                    console.error('点击右上角失败')
                }
            });
        });
    });
    tar.init(TAR_INFO);
}

const wx_init = async function (auth_cb, wxsdk_cb) {
    const token = localStorage.getItem(`${tarTid}_token`);
    let wx_userinfo;
    try {
        if (token) {
            const res = await api.FansInfoByToken({ token });
            if (res.errcode == 40001) {
                localStorage.clear();
                wx_userinfo = await auth();
            } else {
                wx_userinfo = res.data;
            }
        } else {
            wx_userinfo = await auth();
        }
        if (wx_userinfo) {
            TAR_INFO.tar_userinfo = [wx_userinfo];
            tar.init(TAR_INFO);
            wxConfig(wxsdk_cb);
            api.getTitle({ eventid: TAR_INFO.tar_tid });
            auth_cb();
        }
    } catch (error) {
        console.log(error)
    }
}

async function auth() {
    try {
        const AuthUrl = async function () {
            const res = await api.getAuthCfg({
                c_appid: AUTH_INFO.c_appid,
                appid: AUTH_INFO.authAppid,
                scope: AUTH_INFO.scope,
                callback_url: window.location.href,
                mode: 'all'
            });
            window.location.href = res.apiurl;
        }
        const code = getUrlParam('code');
        if (code) {
            const res = await api.FansInfoByAuth({
                code: code,
                appid: AUTH_INFO.authAppid,
                c_appid: AUTH_INFO.c_appid
            });
            if (res.token) {
                localStorage.setItem(`${tarTid}_token`, res.token);
                localStorage.setItem(`${AUTH_INFO.authAppid}_openid`, res.data.openid);
                return res.data;
            } else {
                AuthUrl();
            }
        } else {
            AuthUrl();
        }
    } catch (error) {
        console.log(error)
    }
}

async function wxConfig(wxsdk_cb) {
    try {
        let version = 'busone';
        if (DOMAIN_ARR.busone.includes(window.location.hostname)) {
            version = 'busone';
        }
        if (DOMAIN_ARR.carsonone.includes(window.location.hostname)) {
            version = 'carsonone';
        }
        const res = await api.getWxShareCfg({
            version: version,
            shareurl: window.location.href,
            shareappid: 'wxe512506924dfd7b6'
        });
        wx.config({
            debug: false,
            appId: res.appid,
            timestamp: res.timestamp,
            nonceStr: res.noncestr,
            signature: res.signature,
            jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage", "onMenuShareQQ", "onMenuShareWeibo", "onMenuShareQZone", "startRecord", "stopRecord", "onVoiceRecordEnd", "playVoice", "pauseVoice", "stopVoice", "onVoicePlayEnd", "uploadVoice", "downloadVoice", "chooseImage", "previewImage", "uploadImage", "downloadImage", "translateVoice", "getNetworkType", "openLocation", "getLocation", "hideOptionMenu", "showOptionMenu", "hideMenuItems", "showMenuItems", "hideAllNonBaseMenuItem", "showAllNonBaseMenuItem", "closeWindow", "scanQRCode", "chooseWXPay", "openProductSpecificView", "addCard", "chooseCard", "openCard", "openAddress"],
            openTagList: ['wx-open-launch-app', 'wx-open-launch-weapp', 'wx-open-subscribe']
        });
        wx.ready(function () {
            const channel = getUrlParam('channel');
            if (channel) {
                WX_SHARE.link = `${WX_SHARE.link}?channel=${channel}`;
            }
            wx.onMenuShareAppMessage(tar.shapeShareAppMessage(WX_SHARE));
            wx.onMenuShareTimeline(tar.shapeShareTimeline(WX_SHARE));
            console.log('Show Menu!');
            WeixinJSBridge.call('showOptionMenu');
            document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
                WeixinJSBridge.call('showOptionMenu');
            });
            wxsdk_cb();
        })
    } catch (error) {
        console.log(error)
    }
}

export { wx_init, dd_init, not_wx_dd_init }
